import {createAction} from '@reduxjs/toolkit';


export const initialState = {
  theme: 'theme2',
};

export const theme = createAction('root/changeTheme');
